export enum DownloadType {
    downloadQuoteIndicativeProposal = 'DOWNLOAD_QUOTE_INDICATIVE_PROPOSAL',
    downloadQuoteFinalOffer = 'DOWNLOAD_QUOTE_FINAL_OFFER',
    downloadDocumentManagementfile = 'DOWNLOAD_DOCUMENTMANAGEMENT_FILE',
    downloadAddedDocument = 'DOWNLOAD_ADDED_DOCUMENT',
    downloadQuote = 'DOWNLOAD_QUOTE'
}

export const downloadTypes = Object.values(DownloadType) as string[]
